import React from "react";
import {ListItem, SectionHeading} from "../PromotionsText";

const AlterationSection = () => (
  <>
    <SectionHeading>Alteration and Termination of Promotions; Modification of the Rules</SectionHeading>

    <ListItem marker="(a)">
      {"We reserve the right to alter, discontinue or terminate any Promotion, or any aspect of it, at any time, with or without notice, for any reason whatsoever, including without limitation if there has been any printing, production, distribution or other error in any Promotion Communication or on the Platform, or where there has been any error in the preparation for or conduct of any Promotion affecting the result of the Promotion or the number of participants or the value of claims."}
    </ListItem>

    <ListItem marker="(b)" withBottomMargin>
      {"The Rules may be modified by Us at any time by posting the modified terms on the relevant page(s) of the Platform. We recommend You revisit these Promotion Terms regularly. By Your continued participation in the Promotion, You accept any such modified terms."}
    </ListItem>
  </>
);

export default AlterationSection;
